import clsx from 'clsx'
import { type HTMLAttributes, type ReactNode, forwardRef } from 'react'

export interface CardProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  /** Optional title rendered in a header band. */
  title?: ReactNode
  /** Optional actions rendered to the right of the title. */
  actions?: ReactNode
  /** Tighter padding (used in dense lists). */
  dense?: boolean
}

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { title, actions, dense, className, children, ...rest },
  ref,
) {
  return (
    <div
      ref={ref}
      className={clsx(
        // Apple-style: white surface, hairline border, soft 16px radius.
        'rounded-[var(--radius-lg)] border border-[var(--border)] bg-[var(--bg)]',
        className,
      )}
      {...rest}
    >
      {title ? (
        <div
          className={clsx(
            'flex items-center justify-between gap-2 border-b border-[var(--border)]',
            dense ? 'px-3 py-2' : 'px-4 py-3',
          )}
        >
          <div className="text-[14px] font-medium text-[var(--text)]">{title}</div>
          {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
        </div>
      ) : null}
      <div className={dense ? 'p-3' : 'p-4'}>{children}</div>
    </div>
  )
})
